const slideInBottom = (inView: boolean) => ({
  'ease-out duration-500 transition transform-gpu': true,
  'opacity-0 mt-[-40px] translate-y-[40px] pointer-events-none': !inView,
  'opacity-100 mt-0 translate-y-0': inView,
})

export default slideInBottom
